import React, { useEffect, useState, useRef } from 'react';
import { LinkContainer } from "react-router-bootstrap";
import { Button, Label } from "react-bootstrap";
import { useInView } from 'react-intersection-observer';
import { getUser } from "../utils/Common";
import { getLatestStoredImages } from "../utils/bedrockAPI";
import "./CapPanel.css";

const getStatusInfo = (status) => {
  switch (status) {
    case 'POWER_LOSS':
      return { text: 'Power Outage', bsStyle: 'danger' };
    case 'ERROR':
      return { text: 'Cell Signal Weak', bsStyle: 'warning' };
    case 'ONLINE':
      return { text: 'Online', bsStyle: 'success' };
    case 'BATTERY':
      return { text: 'Running on Battery', bsStyle: 'warning' };
    default:
      return { text: status, bsStyle: 'default' };
  }
};

export default function CapPanel({ cap, isLoading, onShareClick }) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const hasTriggered = useRef(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
    rootMargin: '50px 0px'
  });

  // Load image when component becomes visible
  useEffect(() => {
    if (inView && !hasTriggered.current && cap.status === "ACTIVE") {
      hasTriggered.current = true;
      loadImage();
    }
  }, [inView, cap]);

  const loadImage = async () => {
    try {
      const savedUrls = await getLatestStoredImages(cap.capid);
      // console.log("Saved URLs for", cap.capid, savedUrls);
      // console.log("cap",cap,savedUrls);
      if (savedUrls) {
        let selectedMonitor = Object.keys(savedUrls)[0];
        if(cap.defaultmonitorid) {
          selectedMonitor = cap.defaultmonitorid;
        }
        if (selectedMonitor) {
          // selectedMonitor.accessDate = new Date();
          setPreviewImage(savedUrls[selectedMonitor]);
        }
      }
    } catch (e) {
      console.error("Error loading cap preview:", e);
    }
  };
  
  const statusInfo = getStatusInfo(cap.health);
  
  return (
    <LinkContainer to={`/caps/${cap.capid}`} className="cap-panel-link">
      <div ref={ref} data-capid={cap.capid} className="cap-panel">
        <div className="cap-preview">
          {previewImage ? (
            <img 
              src={previewImage.url} 
              alt={`${cap.name} preview`}
              className={`preview-image ${imageLoaded ? 'loaded' : ''}`}
              loading="lazy"
              onLoad={(e) => {
                setImageLoaded(true);
                e.target.classList.add('loaded');
              }}
            />
          ) : (
            <div className="no-preview">No Preview Available</div>
          )}
        </div>
        <div className="cap-info">
          <div className="cap-name-row">
            <h3 className="cap-name">{cap.name}</h3>
            {cap.neighborhood && <div className="cap-neighborhood">{cap.neighborhood}</div>}
          </div>
          <div className="cap-status-row">
            <Label bsStyle={statusInfo.bsStyle} className="cap-status">
              {statusInfo.text}
            </Label>
            {getUser().caps[cap.capid].accessType === "OWNER" && (
              <Button 
                bsStyle="info"
                bsSize={isMobile ? "small" : null}
                disabled={isLoading}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onShareClick(cap);
                }}
              >
                <b>Share Camera</b>
              </Button>
            )}
          </div>
        </div>
      </div>
    </LinkContainer>
  );
} 